<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-05-25 14:28:03
 * @LastEditors: zhangle
 * @LastEditTime: 2023-02-22 16:34:01
-->
<template>
    <div class="tsa-realName">
        <iframe id="child" :src="src" frameborder="0" @load="iframeOnload"></iframe>
    </div>
</template>

<script>
import { getCookie } from '@/js/utils.js'
import Messager from '@/js/messenger_ext';
export default {
    name: 'tsa-realName',
    data() {
        return {
            src: '',
            type: this.$route.query.type
        }
    },
    created() {
        let access_token = getCookie('access_token')
        let identifyType = ''
        let src = ''
        if (this.type === 'PERSON') {
            identifyType = '&identifyType=1'
            src = process.env[`VUE_APP_${this.type}_REALNAME`] + decodeURIComponent(access_token) + identifyType
        } else if (this.type === 'ENTERPRISE') {
            // VUE_APP_ENTERPRISE_REALNAME
            src = process.env[`VUE_APP_${this.type}_REALNAME`] + decodeURIComponent(access_token) + identifyType
            if (this.$route.query.page) {
                src = src.replace('?', 'realName/'+this.$route.query.page+'?')
            }

        } else {
            identifyType = '&identifyType=1'
            src = process.env[`VUE_APP_AuthenticationName`] + decodeURIComponent(access_token) + identifyType
        }
        this.src = src
    },
    mounted() {
        var M = new Messager('parent', 'realName');
        M.addTarget(document.getElementById('child').contentWindow, 'childWindow');
        M.response('pageReload', () => {
            window.location.reload()
        })
        M.response('quit', (data, done) => {
            this.$router.replace({
                path: '/main',
            })
        });
        M.response('getParamUrl', (data,done) => {
            let selfUrl=window.location.href;
            let result = {
                url:'',
                windowUrl:selfUrl
            };
            if (this.type === 'ENTERPRISE') {
                if (selfUrl.indexOf("?") === -1) {
                    result.url=selfUrl+'?page=enterpriseSuccess'
                }else{
                    //有一种情况是人脸失败后重新认证，会带一个page为personalInfo的参数，若当前是这个参数，那么要替换成enterpriseSuccess在返给子页面
                    if(this.getUrlParam(selfUrl,'page')){
                        result.url=this.replaceParamVal(`${selfUrl}`,'page','enterpriseSuccess')
                    }else{
                        result.url=selfUrl+'&page=enterpriseSuccess'
                    }
                }
            } else if (this.type === 'PERSON') {
                result.url = window.location.href.split('?')[0].replace('realName', 'main')
            } else {
                result.url = window.location.href.split('?')[0].replace('realName', 'main')
            }
            done(result);
        })
        M.response('goFace', (data) => {
            //给子页面传递回调地址
            console.log('进入goFace')
            setTimeout(() => {
                //传递参数后，跳转到人脸核身
                window.location.href = data.url;
            }, 500);

        });
        M.response('goUserInfo', (data,done) => {
            let result = {
                url: this.src
            };
            done(result);
        });
    },
    methods: {
        // 获取制定参数
        getUrlParam(url,paraName) {
            var arrObj = url.split("?");
            if (arrObj.length > 1) {
                var arrPara = arrObj[1].split("&");
                var arr;
                for (var i = 0; i < arrPara.length; i++) {
                    arr = arrPara[i].split("=");
                    if (arr != null && arr[0] == paraName) {
                        return arr[1];
                    }
                }
                return "";
            }else {
                return "";
            }
        },
        //替换指定传入参数的值,url为地址,paramName为参数,replaceWith为新值
        replaceParamVal(url,paramName,replaceVal) {
            var oUrl = url.toString();
            var re=eval('/('+ paramName+'=)([^&]*)/gi');
            var nUrl = oUrl.replace(re,paramName+'='+replaceVal);
            return nUrl;
        },
        iframeOnload () {
            
        }
    },
}
</script>

<style scoped>
    .tsa-realName {
        width: 100%;
        height: 100%;
        -webkit-overflow-scrolling: touch;  
        overflow-y: scroll;
    }
    .tsa-realName iframe {
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/module/realName/index.vue